// extracted by mini-css-extract-plugin
module.exports = {"root":"ControlBtn_root__vWY89","active":"ControlBtn_active__27rEi"};